<template>
  <div id="app">
    <!-- 导航栏 -->
    <div class="navContainer">
      <div class="navBox">
        <div style="height: 60px" class="logo" @click="openIndex">
          <img
            src="@/assets/logo_img.png"
            alt="logo"
            style="height: 100%; vertical-align: bottom"
          />
        </div>
        <!-- :default-active="$route.path" -->
        <el-menu
          :router="true"
          mode="horizontal"
          @select="handleSelect"
          text-color="#333"
          active-text-color="#2E6AB0"
        >
          <el-submenu index="1">
            <template slot="title"> 我们的品牌 </template>
            <el-menu-item index="/BrandDescription">
              品谱集团介绍
            </el-menu-item>
            <el-menu-item index="/AboutTetra"> Tetra德彩 </el-menu-item>

            <el-submenu index="/AboutSmartBone/About">
              <template slot="title">Smartbones</template>
              <el-menu-item index="/AboutSmartBone/About">
                品牌介绍
              </el-menu-item>
              <el-menu-item index="/AboutSmartBone/SmartBonesClassic"
                >洁齿骨经典系列
              </el-menu-item>
              <el-menu-item index="/AboutSmartBone/SmartBonesFunction">
                洁齿骨功能系列
              </el-menu-item>
              <el-menu-item index="/AboutSmartBone/SmartBonesInnovation">
                洁齿骨创新系列
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="/AboutFurminator"> 富美内特 </el-menu-item>
            <el-menu-item index="/AboutNatureMiracle"> 天然奇迹 </el-menu-item>
          </el-submenu>

          <el-submenu index="/AllProduct">
            <template slot="title"> 我们的产品 </template>
            <el-menu-item :index="'/AllProduct/Tetraproduct?categoryId=' + category.id" router v-for="category in categoryList">
              {{category.name}}
            </el-menu-item>
          </el-submenu>

          <el-menu-item index="/BrandNews"> 我们的动态 </el-menu-item>

          <el-menu-item index="/Distributor"> 经销商信息 </el-menu-item>

          <el-menu-item index="/contactUs"> 联系我们 </el-menu-item>
        </el-menu>
      </div>
    </div>
    <router-view></router-view>

    <!-- 回到顶部 -->
    <el-backtop :bottom="100" :visibility-height="200">
      <div
        style="
           {
            height: 60px;
            width: 60px;
            background-color: #f2f5f6;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.03);
            text-align: center;
            line-height: 40px;
            color: #999;
            border-radius: 50%;
          }
        "
      >
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
const token = '1c3265b23f05b421e78e82e6ea287214'
const encryptToken = CryptoJS.AES.encrypt(
  new Date().getTime().toString(),
  token
).toString();

export default {
  data() {
    return {
      activeIndex: "0",
      categoryList: null
    };
  },

  created() {
    document.title = '品谱';
    this.getData()
  },

  methods: {
    handleSelect(index, indexPath) {
      console.log(index, indexPath);
    },
    openIndex() {
      this.$router.push("/");
    },
    //获取数据
    getData() {
      //接口地址已通过跨域处理
      this.$axios.post("/mini/v1/category/list", {
        cid: 611,
        type: 1,
        encryptToken
      },{
        header: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        }
      }).then(res=>{
        this.categoryList = res.data.data.categoryList
      })
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  .navContainer {
    background-color: #fff;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
  }
  p {
    margin: 0;
    padding: 0;
  }
  .navBox {
    width: 1200px;
    margin: 0 auto;

    background-color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    .logo {
      margin-right: 20px;
    }
    .el-submenu .el-submenu__title {
      font-size: 16px;
    }

    .el-submenu .el-submenu__title:hover {
      background-color: #ebeef5 !important;
    }
    .el-menu-item {
      font-size: 16px !important;
    }

    .el-menu-item:hover {
      background-color: #ebeef5 !important;
    }
  }
}
</style>
